import React from "react";

const JourneyStepper = ({ currentStep = 1, disbursalAmount = 0, maxSequence }) => {
  const totalSteps = Number(maxSequence) > 0 ? maxSequence : Number(disbursalAmount) > 1000000 ? 4 : 3;
  const steps = Array.from({ length: totalSteps }, (_, index) => ({
    id: index + 1,
  }));

  return (
    <>
      <div className="journey-stepper">
        {steps.map((step, index) => {
          const isCompleted = step.id < currentStep;
          const isActive = step.id === currentStep;

          return (
            <React.Fragment key={step.id}>
              <div className="journey-step">
                <div
                  className={`journey-circle ${
                    isCompleted
                      ? "journey-completed"
                      : isActive
                      ? "journey-active"
                      : "journey-pending"
                  }`}
                >
                  {isCompleted ? "✓" : step.id}
                </div>

                <div
                  className={`journey-status ${
                    isCompleted
                      ? "status-completed"
                      : isActive
                      ? "status-active"
                      : "status-pending"
                  }`}
                >
                  {isCompleted
                    ? "Completed"
                    : isActive
                    ? "In Progress"
                    : "Pending"}
                </div>
              </div>

              {index !== steps.length - 1 && (
                <div
                  className={`journey-line ${
                    step.id < currentStep ? "line-completed" : ""
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>

      <style>{`
        .journey-stepper {
          width: 100%;
          display: flex;
          align-items: flex-start;
          padding: 0 15px 10px;
          box-sizing: border-box;
          background: #fff;
        }

        .journey-step {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          min-width: 130px;
        }

        .journey-circle {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 17px;
          font-weight: 600;
          box-sizing: border-box;
          position: relative;
          z-index: 2;
        }

        .journey-completed {
          background: #20a866;
          border: 2px solid #20a866;
          color: #fff;
        }

        .journey-active {
          background: #286ee8;
          border: 2px solid #286ee8;
          color: #fff;
          box-shadow: 0 0 0 5px rgba(40, 110, 232, 0.12);
        }

        .journey-pending {
          background: #fff;
          border: 2px solid #d6dbe2;
          color: #596575;
        }

        .journey-status {
          margin-top: 4px;
          font-size: 12px;
          font-weight: 500;
        }

        .status-completed {
          color: #20a866;
        }

        .status-active {
          color: #286ee8;
        }

        .status-pending {
          color: #6b7280;
        }

        .journey-line {
          flex: 1;
          height: 3px;
          background: #dce1e7;
          margin-top: 14px;
          min-width: 50px;
        }

        .line-completed {
          background: #20a866;
        }

        @media (max-width: 900px) {
          .journey-step {
            min-width: 100px;
          }

          .journey-status {
            font-size: 11px;
          }

          .journey-line {
            min-width: 25px;
          }
        }

        @media (max-width: 600px) {
          .journey-stepper {
            overflow-x: auto;
            padding: 15px 5px 20px;
          }

          .journey-step {
            min-width: 100px;
          }

          .journey-circle {
            width: 36px;
            height: 36px;
            font-size: 14px;
          }

          .journey-line {
            margin-top: 17px;
            min-width: 25px;
          }
        }
      `}</style>
    </>
  );
};

export default JourneyStepper;